import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import { MantineProvider } from '@mantine/core';
import { Provider } from 'react-redux'

import theme from './config/theme';
import CustomRouter from 'config/router';
import store from 'config/redux/index';
import DialogListener from 'listeners/dialog';

function App() {
  return (
    <Provider store={store}>
      <MantineProvider theme={theme}>
        <DialogListener />
        <CustomRouter />
      </MantineProvider>
    </Provider>
  );
}

export default App;
